import React, { createContext, useState } from 'react';

export const InputContext = createContext({
  username: '',
  setGlobalUser: () => {},
  admin: true,
  setAdmin: () => {},
  signOut: () => {}
});

export const UsernameInput = ({ children }) => {
  const [username, setUsername] = useState(() => localStorage.getItem('username') || '');
  const [admin, setAdmin] = useState(() => localStorage.getItem('admin') === 'true');

  const setGlobalUser = (newUsername, isAdmin) => {
    setUsername(newUsername);
    setAdmin(isAdmin);
    localStorage.setItem('username', newUsername);
    localStorage.setItem('admin', isAdmin);
  };

  const signOut = () => {
    setUsername('');
    setAdmin(false);
    localStorage.removeItem('username');
    localStorage.removeItem('admin');
  };

  return (
    <InputContext.Provider value={{ username, setGlobalUser, admin, setAdmin, signOut }}>
      {children}
    </InputContext.Provider>
  );
};

export default InputContext;